import { create } from "zustand";
import { devtools } from "zustand/middleware";
import {
  deleteAreas,
  deleteEmployees,
  editAreas,
  employeeDepartments,
  employeeJobtitle,
  employeeLegacySystem,
  employeeNationality,
  employeePayrollCompany,
  employeePayrolltype,
  employeedepartment,
  exportAreas,
  exportEmployees,
  filterEmployee,
  generatePassword,
  getAreas,
  getAreasTemplate,
  getEmployeeById,
  getEmployeeDepartments,
  getEmployeebyId,
  getEmployees,
  getFieldName,
  getJobtitlebyDept,
  importAreas,
  postAreas,
  postAttributes,
  postEmployees,
  postLoginInfoemployee,
  putEmployeeById,
  resetPasswordEmployee,
  toggleUserstatus,
} from "../../services/Employees/Employee_services";
// Regular employees endpoints (employees/api/v1/employees) — distinct from the
// OS/CS versions of the same names in Employee_services.js used by Outsource.
import {
  getEmployee,
  postEmployee,
  editEmployees,
  exportEmployee,
  getEmployeesTemplate,
  importEmployees,
} from "../../services/aone_services";

const initialValues = {
  jobsData: [],
  departmentData: [],
  payrolltypeData: [],
  nationalityData: [],
  payrollcompanyData: [],
  legacyData: [],
  jobTitleData: [],
  deptData: [],
  employeeData: [],
  employeeAccountData: [],
};

let employeeMgtStore = (set) => ({
  ...initialValues,
  getEmployee: async (params) => {
    const response = await getEmployee(params);
    set({ employeeData: response });
    return response;
  },
  filterEmployee: async (params) => {
    const response = await filterEmployee(params);
    return response;
  },
  getEmployeebyId: async (params) => {
    const response = await getEmployeebyId(params);
    return response;
  },
  postEmployee: async (params) => {
    const response = await postEmployee(params);
    return response;
  },
  editEmployees: async (params, data) => {
    const response = await editEmployees(params, data);
    return response;
  },
  getFieldName: async (params, data) => {
    const response = await getFieldName(params, data);
    return response;
  },
  deleteEmployees: async (params) => {
    const response = await deleteEmployees(params);
    return response;
  },
  exportEmployee: async (params) => {
    const response = await exportEmployee(params);
    return response;
  },
  importEmployees: async (params) => {
    const response = await importEmployees(params);
    return response;
  },
  getEmployeesTemplate: async (params) => {
    const response = await getEmployeesTemplate(params);
    return response;
  },
  employeeJobtitle: async () => {
    const response = await employeeJobtitle();
    set({ jobsData: response });
    return response;
  },
  employeedepartment: async () => {
    const response = await employeedepartment();
    set({ departmentData: response });
    return response;
  },
  employeePayrolltype: async () => {
    const response = await employeePayrolltype();
    set({ payrolltypeData: response });
    return response;
  },
  employeeNationality: async () => {
    const response = await employeeNationality();
    set({ nationalityData: response });
    return response;
  },
  employeePayrollCompany: async () => {
    const response = await employeePayrollCompany();
    set({ payrollcompanyData: response });
    return response;
  },
  employeeLegacySystem: async () => {
    const response = await employeeLegacySystem();
    set({ legacyData: response });
    return response;
  },
  getJobtitlebyDept: async (params) => {
    const response = await getJobtitlebyDept(params);
    set({ jobTitleData: response });
    return response;
  },
  employeeDepartments: async () => {
    const response = await employeeDepartments();
    set({ deptData: response });
    return response;
  },
  getAreas: async (params, params1) => {
    const response = await getAreas(params, params1);
    return response;
  },
  postAreas: async (params, data) => {
    const response = await postAreas(params, data);
    return response;
  },
  editAreas: async (params, params2, data) => {
    const response = await editAreas(params, params2, data);
    return response;
  },
  deleteAreas: async (params) => {
    const response = await deleteAreas(params);
    return response;
  },
  exportAreas: async (params, params2) => {
    const response = await exportAreas(params, params2);
    return response;
  },
  getAreasTemplate: async (params) => {
    const response = await getAreasTemplate(params);
    return response;
  },
  importAreas: async (params, data) => {
    const response = await importAreas(params, data);
    return response;
  },
  postLoginInfoemployee: async (params,data) => {
    const response = await postLoginInfoemployee(params,data);
    return response;
  },
  postAttributes: async (data) => {
    const response = await postAttributes(data);
    return response;
  },
  resetPasswordEmployee: async (params) => {
    const response = await resetPasswordEmployee(params);
    return response;
  },
  toggleUserstatus: async (params, params2) => {
    const response = await toggleUserstatus(params, params2);
    return response;
  },
  generatePassword: async () => {
    const response = await generatePassword();
    return response;
  },
  getEmployeeDepartments: async () => {
    const response = await getEmployeeDepartments();
    return response;
  },
  getEmployees: async (params) => {
    const response = await getEmployees(params);
    return response;
  },
  postEmployees: async (data) => {
    const response = await postEmployees(data);
    return response;
  },
  getEmployeeById: async (params) => {
    const response = await getEmployeeById(params);
    set({ employeeAccountData: response });
    return response;
  },
  putEmployeeById: async (params, data) => {
    const response = await putEmployeeById(params, data);
    return response;
  },
  exportEmployees: async (params) => {
    const response = await exportEmployees(params);
    return response;
  },
});

employeeMgtStore = devtools(employeeMgtStore);

export const useEmployeeMgtStore = create(employeeMgtStore);
